<div class="container">
  <div class="container__background"></div>
  <div class="container__content">
    <div class="content">
      <div class="content__caption">
        <h1 class="caption">「あなたはこの世界の主人公だよ」</h1>
      </div>
      <div class="content__text">
        <p class="text">BÜKIは誰もが主人公になれる絵本で、子供たちが自分自身にワクワクし続けられる社会を目指しています。</p>
      </div>
      <div class="content__text">
        <p class="text">子供はみんな、特別な存在だから。</p>
      </div>
    </div>
  </div>
</div>
